import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Menu,
  MenuItem,
  SvgIcon,
  Typography,
} from '@material-ui/core'
import { mdiChevronDown } from '@mdi/js'

import { sortTimeseriesByTitle } from '../../utils/sorting'
import CommunityUnitNameContainer from '../controls/CommunityUnitNameContainer'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class TimeseriesNavContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    timeseriesId: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    unitId: PropTypes.number,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  static defaultProps = {
    unitId: null,
  }

  static styles = () => ({
    breadcrumb: {
      display: 'inline',
    },
    timeseries: {
      padding: 0,
      textTransform: 'none',
      display: 'inline',
      verticalAlign: 'baseline', // Align with breadcrumb
    },
    timeseriesDropdownIcon: {
      verticalAlign: 'bottom', // Align with timeseries text
    },
  })

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  state = {
    anchorEl: null,
    open: false,
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  openMenu = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  }

  closeMenu = () => {
    this.setState({ open: false })
  }

  selectItem = (timeseries) => {
    this.closeMenu()
    this.props.history.push({
      ...this.props.location,
      pathname: `/units/${timeseries.unit_id}/timeseries/${timeseries.id}`,
    })
  }

  update() {
    const {
      timeseriesId, timeseriesActions,
    } = this.props
    timeseriesActions.fetchTimeseries(timeseriesId)
    if (this.unitId()) {
      timeseriesActions.listUnitTimeseries(this.unitId())
    }
  }

  timeseries() {
    const {
      timeseriesId, timeseries,
    } = this.props
    return timeseries[timeseriesId]
  }

  unitId() {
    const { unitId } = this.props
    // If it's not passed in, grab it from timeseries
    return unitId || (this.timeseries() || {}).unit_id
  }

  unitTimeseries() {
    const {
      timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[this.unitId()] || []
    const unitTimeseries = []
    tsIds.forEach((id) => {
      unitTimeseries.push(timeseries[id])
    })
    return sortTimeseriesByTitle(unitTimeseries)
  }

  render() {
    const { classes } = this.props
    const delimiter = '/'

    return (
      <>
        <Typography variant="subtitle1" className={classes.breadcrumb}>
          <CommunityUnitNameContainer unitId={this.unitId()} linkable delimiter={delimiter} />
          {` ${delimiter} `}
        </Typography>

        <Button onClick={this.openMenu} className={classes.timeseries}>
          <Typography variant="subtitle1">
            {this.timeseries().title}
            <SvgIcon className={classes.timeseriesDropdownIcon}>
              <path d={mdiChevronDown} />
            </SvgIcon>
          </Typography>
        </Button>
        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.closeMenu}
        >
          {this.unitTimeseries().map((ts) => (
            <MenuItem
              key={ts.id}
              selected={ts.id === this.props.timeseriesId}
              onClick={() => this.selectItem(ts)}
            >
              {ts.title}
            </MenuItem>
          ))}
        </Menu>
      </>
    )
  }
}

export default connect(
  TimeseriesNavContainer.mapStateToProps,
  TimeseriesNavContainer.mapDispatchToProps,
)(withStyles(TimeseriesNavContainer.styles)(withRouter(TimeseriesNavContainer)))
